import type {
  PrinterPageSize,
  PrinterRollWidth,
  PrinterType,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const printerUpdateAtom = createMutationAtomFactory(
  'settings.printerUpdate',
  (params: {
    id: string;
    name?: string;
    printerType?: PrinterType | null;
    pageSize?: PrinterPageSize | null;
    rollWidth?: PrinterRollWidth | null;
  }) => ({
    iotPrinterUpdate: {
      __args: {
        id: params.id,
        input: {
          name: params.name,
          printerType: params.printerType,
          pageSize: params.pageSize,
          rollWidth: params.rollWidth,
        },
      },
      id: true,
      name: true,
      printerType: true,
      pageSize: true,
      rollWidth: true,
      status: true,
    },
  }),
);
